import { useEffect, useState } from 'react';
import './input.css';

function Input({
    className, 
    type,
    placeholder,
    value,
    disable,
    onChange = () => {},
    onValidate = () => {},
    warningMsg,
    shouldValidate,
    maxLength
}) {
    const [invalidValue, setInvalidValue] = useState(false);

    useEffect(() => {
        if (shouldValidate)
            setInvalidValue(!onValidate());
    }, [shouldValidate, onValidate]);

    return (
        <div className='input-container'>
            <input
                className={className}
                type={type}
                placeholder={placeholder}
                value={value}
                disabled={disable}
                onChange={(e) => {
                    setInvalidValue(false);
                    onChange(e);
                }}
                onBlur={() => setInvalidValue(!onValidate())}
                maxLength={maxLength}
            />
            <span className={`input-warning-msg ${invalidValue ? 'show' : ''}`}>
                {warningMsg}
            </span>

        </div>
    );
}

export default Input;